import { render, staticRenderFns } from "./WidgetPasajeros.vue?vue&type=template&id=6a24ee4e&lang=pug"
import script from "./WidgetPasajeros.vue?vue&type=script&lang=js"
export * from "./WidgetPasajeros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports